<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft">
    <div :class="$style.dropdown">
      <a-avatar shape="square" icon="user" size="large" :class="$style.avatar" />
    </div>
    <a-menu slot="overlay">
      <a-menu-item>
        <strong>{{ $t('topBar.profileMenu.hello') }}, {{ user.username }}</strong>
        <div>
          <strong>{{ $t('topBar.profileMenu.role') }}:</strong>
          {{ user.role }}
        </div>
      </a-menu-item>
      <a-menu-divider />
      <!-- <a-menu-item>
        <a href="javascript: void(0);">
          <i :class="$style.menuIcon" class="fe fe-user"></i>
          {{ $t('topBar.profileMenu.editProfile') }}
        </a>
      </a-menu-item> -->
      <a-menu-item>
        <a href="javascript: void(0);" @click="logout">
          <i :class="$style.menuIcon" class="fe fe-log-out"></i>
          {{ $t('topBar.profileMenu.logout') }}
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import authType from '@/store/types/auth'

export default {
  computed: {
    ...mapGetters({
      user: authType.getters.getUser,
    }),
  },
  methods: {
    ...mapActions({
      logout: authType.actions.logout,
    }),
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
